// Booking form constants and configuration

export const BOOKING_STEP_IDS = {
  PERSONAL_DETAILS: 'personal_details',
  EVENT_DETAILS: 'event_details',
  SCHEDULE_CONFIRMATION: 'schedule_confirmation',
  REVIEW_PAYMENT: 'review_payment'
};

export const MAIN_BOOKING_FLOW = [
  {
    id: BOOKING_STEP_IDS.PERSONAL_DETAILS,
    number: 1,
    title: 'Personal Details',
    icon: '👤',
    validator: 'personal'
  },
  {
    id: BOOKING_STEP_IDS.EVENT_DETAILS,
    number: 2,
    title: 'Event Details',
    icon: '📅',
    validator: 'event'
  },
  {
    id: BOOKING_STEP_IDS.SCHEDULE_CONFIRMATION,
    number: 3,
    title: 'Schedule Confirmation',
    icon: '🗓️',
    validator: 'schedule'
  },
  {
    id: BOOKING_STEP_IDS.REVIEW_PAYMENT,
    number: 4,
    title: 'Review & Payment',
    icon: '💳',
    validator: 'payment'
  }
];

export const SINGLE_STEP_BOOKING_FLOW = [
  {
    id: BOOKING_STEP_IDS.PERSONAL_DETAILS,
    number: 1,
    title: 'Booking Details',
    icon: '📝',
    validator: 'single'
  }
];

export const BOOKING_STEPS = MAIN_BOOKING_FLOW;

export const VENUE_TYPES = [
  { value: 'home', label: 'Home' },
  { value: 'hall', label: 'Banquet Hall' },
  { value: 'temple', label: 'Temple' },
  { value: 'garden', label: 'Garden/Outdoor' },
  { value: 'hotel', label: 'Hotel' },
  { value: 'other', label: 'Other' }
];

export const GUEST_COUNT_OPTIONS = [
  { value: '', label: 'Select guest count' },
  { value: '1-25', label: '1-25 guests' },
  { value: '26-50', label: '26-50 guests' },
  { value: '51-100', label: '51-100 guests' },
  { value: '101-200', label: '101-200 guests' },
  { value: '201+', label: '201+ guests' }
];

export const PAYMENT_METHODS = [
  {
    value: 'online',
    label: 'Online Payment',
    description: 'Pay advance amount online (30% of total)'
  },
  {
    value: 'cash',
    label: 'Cash on Service',
    description: 'Pay full amount on the day of service'
  }
];

export const SERVICE_GUARANTEES = [
  { icon: '✅', text: '100% Satisfaction Guaranteed' },
  { icon: '🔒', text: 'Secure Payment Processing' },
  { icon: '📞', text: '24/7 Customer Support' },
  { icon: '⏰', text: 'On-time Service Guarantee' }
];

export const FORM_VALIDATION = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  phone: /^\d{10}$/
};

export const DEFAULT_FORM_DATA = {
  // Personal Information
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  
  // Event Details
  eventDate: '',
  eventTime: '',
  venue: '',
  venueType: 'home',
  address: '',
  city: '',
  state: '',
  pincode: '',
  
  // Guest Information
  expectedGuests: '',
  specialRequirements: '',
  
  // Payment Information
  paymentMethod: 'online',
  
  // Terms and Conditions
  scheduleConfirmed: false,
  termsAccepted: false,
  newsletterSubscription: false
};

export const ADVANCE_PAYMENT_PERCENTAGE = 0.3; // 30%
